import { Component, OnInit } from '@angular/core';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import {RoleService } from 'src/app/services/role/role.service';
import { Role } from 'src/app/model/role/role.model';
import { Roleassign } from 'src/app/model/role/roleassign.model';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { RoleguardServiceGuard } from 'src/app/auth/roleguard-service.guard';
//import swal from 'sweetalert';
import { UserService } from 'src/app/services/user/user.service';


@Component({
  selector: 'app-roleassignment',
  templateUrl: './roleassignment.component.html',
  styleUrls: ['./roleassignment.component.css']
})
export class RoleassignmentComponent implements OnInit {
data:any;
roles: Roleassign[];
role:Roleassign;
name:string;
description:string;
companyName:string;

  constructor(private roleservice:RoleService,private router:Router,private userService:UserService) { }

  ngOnInit() {

    this.role=new Roleassign();
    this.userService.currentCompany.subscribe(
      (data)=>
      {
        this.companyName=data;
      }
    )

    this.getUserRoles();
  }
getUserRoles(){
  //swal("hello")
  //debugger;
this.roleservice.roleFunctionality().subscribe(
  data=>{
    //debugger;
    this.data=data;
    console.log(data);
  }

)
}

  OnClick(id:number)
  {
    //debugger;
    var element = <HTMLInputElement> document.getElementById("checkbox2"+id);

    var isChecked = element.checked;
    if(isChecked)
     {
      var element = <HTMLInputElement> document.getElementById("checkbox1"+id);
      element.checked=true;
     }
  }
  SubmitForm(form:NgForm)
  {

    debugger;
    this.roles = new Array<Roleassign>();

    for(let item of this.data)
    {
      debugger;
      this.role = new Roleassign();
      this.role.name = form.value.name;
      this.role.companyName=this.companyName;
      this.role.description = form.value.description;
      this.role.userObjectId = item.id;
      var element1 = <HTMLInputElement> document.getElementById("checkbox2"+item.id);
      var isChecked1 = element1.checked;
      var element2 = <HTMLInputElement> document.getElementById("checkbox1"+item.id);
      var isChecked2 = element2.checked;
      if(isChecked1)
      {
        this.role.crud=true;
        this.role.read=true;
      }

      else
      {
        if(isChecked2)
         {
          this.role.read=true;
          this.role.crud=false;
         }
        else
        {
          this.role.crud=false;
          this.role.read=false;
        }

      }
      this.roles.push(this.role);
    }
    console.log(this.roles);
    this.roleservice.saverole(this.roles).subscribe(
      data=>{

        this.router.navigate(['/userrole']);
        console.log(data);
      }

    )
  }
  cancel()
  {
    this.router.navigate(['/userrole']);
  }


}

